export const BasketPageTokenUpdaterView = () => {
  return null;
};
